const SEPARATOR_REGEX = / *; */;

export default function getCookies() {
  let cookies = {};
  let pairs = document.cookie.split(SEPARATOR_REGEX);

  for (let i = 0; i < pairs.length; i++) {
    let pair = pairs[i].split('=');
    cookies[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }

  return cookies;
}

